import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'app-standard-page',
  templateUrl: './standard-page.component.html',
  styleUrls: ['./standard-page.component.scss']
})
export class StandardPageComponent implements OnInit {
  constructor(public core: CoreService, public auth: AuthService) { }

  public sideNavActive = false;

  ngOnInit(): void {
  }

  linkActive(url: string) {
    if (this.auth.router.isActive(url)) {
      return 'active'
    } else {
      return ''
    }
  }


}
